import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { PrognoseIndstillinger } from "../model/prognose-indstillinger.model";
import { Prognose } from "../model/prognose.model";
import { PrognoseViewModel } from "../model/prognose.view-model";
import { PrognoseRepository } from "./prognose.repository";

@Injectable({ providedIn: "root" })
export class PrognoseService {
    constructor(private readonly repository: PrognoseRepository) {}

    public hentData(): Observable<PrognoseViewModel> {
        const indstillinger$ = this.hentIndstillinger();
        const prognose$ = indstillinger$.pipe(switchMap(i => this.hentPrognose(i.forbrugstype)));
        return combineLatest([prognose$, indstillinger$]).pipe(map(([prognose, indstillinger]) => this.map(prognose, indstillinger)));
    }

    public hentPrognose(forbrugstype: string): Observable<Prognose> {
        return this.repository.hentPrognose(forbrugstype);
    }

    public hentIndstillinger(): Observable<PrognoseIndstillinger> {
        return this.repository.hentIndstillinger();
    }

    private map(prognose: Prognose, indstillinger: PrognoseIndstillinger): PrognoseViewModel {
        return {
            prognose,
            ...indstillinger
        };
    }
}
